import { SLICE_TAG } from '@/constants';

import { apiSlice } from '../api-slice';
import {
    BalanceHistoryResponseSchema,
    type TodayBalanceItem,
    TodayBalanceResponseSchema,
} from './balance-history.schema';

type CreateBalanceHistoryPayload = {
    date: string;
    starting_balance: number;
};

type UpdateBalanceHistoryPayload = {
    id: string;
    starting_balance?: number;
    ending_balance?: number;
};

export const balanceHistoryApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getBalanceHistory: builder.query({
            query: (params) => {
                return {
                    url: 'balance-history',
                    method: 'GET',
                    params,
                };
            },
            keepUnusedDataFor: 600,
            providesTags: [SLICE_TAG.BALANCE_HISTORY],
            transformResponse: (response) => {
                return BalanceHistoryResponseSchema.parse(response);
            },
        }),
        createOpeningBalance: builder.mutation<
            unknown,
            CreateBalanceHistoryPayload
        >({
            query: (body) => {
                return {
                    url: 'balance-history',
                    method: 'POST',
                    body,
                };
            },
            invalidatesTags: [SLICE_TAG.BALANCE_HISTORY],
        }),
        updateBalanceHistory: builder.mutation<
            unknown,
            UpdateBalanceHistoryPayload
        >({
            query: ({ id, ...body }) => {
                return {
                    url: `balance-history/${id}`,
                    method: 'PUT',
                    body,
                };
            },
            invalidatesTags: [SLICE_TAG.BALANCE_HISTORY],
        }),
        getTodayBalance: builder.query<TodayBalanceItem | null, void>({
            query: () => ({
                url: 'balance-history/today',
                method: 'GET',
            }),
            providesTags: [SLICE_TAG.BALANCE_HISTORY],
            transformResponse: (response) => {
                return TodayBalanceResponseSchema.parse(response).data;
            },
        }),
    }),
});

export const { useGetBalanceHistoryQuery, useLazyGetBalanceHistoryQuery } =
    balanceHistoryApi;

export const { useCreateOpeningBalanceMutation } = balanceHistoryApi;
export const { useUpdateBalanceHistoryMutation } = balanceHistoryApi;
export const { useGetTodayBalanceQuery } = balanceHistoryApi;
